import { message } from 'antd'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import request from 'meinian-package/src/utils/request'

export default () => {
  const onEditTask = (record, callback) => { // 修改
    callback?.()
  }

  const onEndTask = (record, callback) => { // 终止
    ModalConfirm.show({
      title: '终止选款任务',
      content: '是否终止该选款任务',
      onOk: async () => {
        const success = await request.get('/zhikuan/ins/blog/mission/blog-mission-terminal', { params: { missionId: record.id } })
        if (success) {
          message.success('成功')
          callback?.()
        }
      },
    })
  }
  const onDeleteTask = (record, callback) => {
    ModalConfirm.show({
      title: '是否删除',
      content: '确定删除该选款任务？',
      onOk: async () => {
        const success = await request.get('/zhikuan/ins/blog/mission/delete-blog-mission', { params: { missionId: record.id } })
        if (success) {
          message.success('删除成功')
          callback?.()
        }
      }
    })
  }
  return {
    onEditTask,
    onEndTask,
    onDeleteTask,
  }
}
